/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  $('[data-carousel]').each((i, container) => {
    createSwiper(container)
  })
}

function loadSwiper() {
  return import(/* webpackChunkName: "Swiper" */ 'swiper/dist/js/swiper.js').then(c => c.default)
}

function createSwiper(container) {
  loadSwiper().then(Swiper => {
    const swiper = new Swiper(container, {
      slidesPerView: 'auto',
      loop: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 6,
        loadOnTransitionStart: true,
        elementClass: 'lazy',
      },
      navigation: {
        nextEl: '[data-button-next]',
        prevEl: '[data-button-prev]',
      },
    })
  })
}
